<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: '90%' }" @close="closeDialog">
    <van-nav-bar title="获取定位" left-text="取消" right-text="确认" @click-left="closeDialog"
      @click-right="() => closeDialog('confirm')" />

    <div class="content">
      <div id="phonesign_container" class="map-container"></div>

      <van-cell-group inset>
        <van-field label-width="1.5rem" v-model="address" label="搜索" placeholder="请输入地点名称" clearable @change="search">
          
        </van-field>

        <van-row gutter="10">
          <van-col span="12">
            
            <van-field label-width="1.5rem" v-model="row.jd" label="经度" placeholder="经度" />
          </van-col>
          <van-col span="12">
            <van-field label-width="1.5rem" v-model="row.wd" label="纬度" placeholder="纬度" />
          </van-col>
        </van-row>

        <van-field label-width="1.5rem" v-model="row.radius" label="半径(米)" placeholder="请输入半径" />

        <van-field label-width="1.5rem" v-model="row.def_sign_place" label="地址" type="textarea" rows="2" placeholder="详细地址" />
      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { getFirstSignRuleName, getMapKeyPwdSet } from '@/api/wx.js'
import { showToast } from 'vant'

export default {
  props: {},
  data() {
    return {
      show: false,
      center: [113.2932, 22.805412],
      map: null,
      marker: null,
      geocoder: null,
      circle: null,
      row: {
        jd: null,
        wd: null,
        radius: 200,
        def_sign_place: "",
      },
      address: ''
    }
  },
  unmounted() {
    this.cleanupMap()
  },
  watch: {
    row: {
      handler(n) {
        if (n.jd && n.wd && n.radius && this.map) {
          this.setCenter(n)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async ini() {
      this.show = true
      await this.$nextTick() // 确保DOM已渲染

      const userInfo = localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : this.$route.query.formoutSize == "1"
          ? { userid: 1, username: "admin" } // 外部人员打开单据时用到
          : {};
      const res1 = await getFirstSignRuleName({
        username: userInfo.username
      })
      const sign_rulename = res1.data[0].sign_rulename
      const res2 = await getMapKeyPwdSet({ sign_rulename: sign_rulename })
      const rawDataMapkey = res2.data[0]

      if (this.row.jd && this.row.wd) {
        this.center = [this.row.jd, this.row.wd]
      }

      window._AMapSecurityConfig = {
        securityJsCode: rawDataMapkey.map_secret
      }

      AMapLoader.load({
        key: rawDataMapkey.map_key,
        version: '2.0',
        plugins: ['AMap.Geocoder']
      }).then(AMap => {
        this.map = new AMap.Map('phonesign_container', {
          // 设置地图容器id
          viewMode: '3D', // 是否为3D地图模式
          zoom: 15, // 初始化地图级别
          center: this.center // 初始化地图中心点位置
        })
        this.map.on('click', ev => {
          this.$set(this.row, 'jd', ev.lnglat.lng)
          this.$set(this.row, 'wd', ev.lnglat.lat)
          this.geocoder.getAddress(
            [ev.lnglat.lng, ev.lnglat.lat],
            (status, result) => {
              if (status === 'complete' && result.regeocode) {
                this.$set(this.row, 'def_sign_place', result.regeocode.formattedAddress)
              }
              // this.$forceUpdate();
            }
          )
          if (!this.row.radius) this.$set(this.row, 'radius', 200)
          if (this.row.jd && this.row.wd && this.row.radius) {
            this.setCenter(this.row)
          }
        })
        this.geocoder = new AMap.Geocoder({
          radius: 200, //以已知坐标为中心点，radius为半径，返回范围内兴趣点和道路信息
          extensions: 'all' //返回地址描述以及附近兴趣点和道路信息，默认“base”
        })
        if (this.row.jd && this.row.wd && this.row.radius) {
          this.setCenter(this.row)
        }
      })
    },

    initMap() {
      this.map = new AMap.Map('phonesign_container', {
        viewMode: '3D',
        zoom: 15,
        center: this.center,
        touchZoom: true,
        scrollWheel: true
      })

      this.map.on('click', ev => {

        this.$set(this.row, 'jd', ev.lnglat.lng)
        this.$set(this.row, 'wd', ev.lnglat.lat)
        this.geocoder.getAddress(
          [ev.lnglat.lng, ev.lnglat.lat],
          (status, result) => {
            if (status === 'complete' && result.regeocode) {
              this.$set(this.row, 'def_sign_place', result.regeocode.formattedAddress)
            }
          }
        )
        if (!this.row.radius) this.row.radius = 200
        if (this.row.jd && this.row.wd && this.row.radius) {
          this.setCenter(this.row)
        }
      })

      this.geocoder = new AMap.Geocoder({
        radius: 200,
        extensions: 'all'
      })

      if (this.row.jd && this.row.wd && this.row.radius) {
        this.setCenter(this.row)
      }
    },

    setCenter(e) {
      if (this.marker) this.map.remove(this.marker)
      if (this.circle) this.map.remove(this.circle)

      this.map.setCenter([e.jd, e.wd])

      this.marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: [e.jd, e.wd],
        anchor: 'bottom-center'
      })
      this.map.add(this.marker)

      this.circle = new AMap.Circle({
        center: new AMap.LngLat(e.jd, e.wd),
        radius: e.radius,
        strokeColor: '#057de7',
        strokeOpacity: 0.2,
        strokeWeight: 2,
        fillColor: '#1791fc',
        fillOpacity: 0.35
      })
      this.map.add(this.circle)

    },

    search() {
      if (!this.address) return

      this.geocoder.getLocation(this.address, (status, result) => {
        if (status === 'complete' && result.geocodes.length) {
          this.$set(this.row, 'jd', result.geocodes[0].location.lng)
          this.$set(this.row, 'wd', result.geocodes[0].location.lat)
          this.$set(this.row, 'def_sign_place', result.geocodes[0].formattedAddress)
          if (!this.row.radius){
            this.$set(this.row, 'radius', 200)
          }
          if (this.row.jd && this.row.wd && this.row.radius) {
            this.setCenter(this.row)
          }
        } else {
          // showToast(this.$t('m9908.text444'))
        }
      })
    },

    closeDialog(action) {
      if (action === 'confirm') {
        if (!this.row.def_sign_place) {
          showToast('请选择地址')
          return
        }

        const str = this.row.def_sign_place + "【" + this.row.jd + "," + this.row.wd + "】"
        this.$emit("getMapLocationFun", str)
      }

      this.show = false
      this.cleanupMap()
    },

    cleanupMap() {
      if (this.marker) {
        this.map.remove(this.marker)
        this.marker = null
      }
      if (this.circle) {
        this.map.remove(this.circle)
        this.circle = null
      }
      this.geocoder = null
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 16px;

  .map-container {
    width: 100%;
    height: 433px;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
  }

  .van-cell-group {
    margin-top: 16px;
  }

  .van-field {
    padding: 10px 0;
  }
}
</style>